<script>
import { mapGetters } from 'vuex';
import EventSelectionRowMobile from './EventSelectionRowMobile.vue';
import SelectionBlackbookComment from './SelectionBlackbookComment.vue';
export default {
  name: 'SelectionBlackbookModal',
  components: {
    EventSelectionRowMobile,
    SelectionBlackbookComment,
  },
  data() {
    return {
      blackbookComments: [],
      inputActive: false,
      blackbookComment: '',
    };
  },
  computed: {
    ...mapGetters({
      modalActive: 'FormGuideEventCard/getBlackbookModalStatus',
      selectionModalData: 'FormGuideEventCard/getSelectionModalData',
      meetingName: 'FormGuideEventCard/getMeetingName',
      raceType: 'FormGuideEventCard/getRaceType',
    }),
    competitor() {
      return this.selectionModalData.competitor || {};
    },
    noComments() {
      return this.blackbookComments ? this.blackbookComments.length == 0 : true;
    },
    inputEmpty() {
      return this.blackbookComment ? this.blackbookComment.length == 0 : true;
    },
    isHarness() {
      return this.raceType == 'harness';
    },
  },
  methods: {
    toggleBlackbookModal() {
      this.$store.dispatch('FormGuideEventCard/toggleBlackbookModal');
    },
    toggleInput(event) {
      this.inputActive = !this.inputActive;

      // set focus on input if active
      if (this.inputActive) {
        this.$nextTick(() => {
          event.preventDefault();
          this.$refs.input.focus();
        });
      }
    },
    submitComment() {
      // TODO: Hook up to API
      if (this.noComments) {
        this.blackbookComments.push({ comment: this.blackbookComment, timeUpdated: new Date() });
      } else {
        this.blackbookComments[0] = { comment: this.blackbookComment, timeUpdated: new Date() };
      }

      this.inputActive = false;
    },
  },
};
</script>

<template>
  <div :class="{ 'select-bb-modal--active': modalActive }" class="select-bb-modal">
    <div class="select-bb-modal-header">
      <a class="select-bb-modal-header__close" href="#" @click.prevent="toggleBlackbookModal">
        <div class="select-bb-modal-header__close-icon"></div>
      </a>

      <div class="select-bb-modal-header__title">
        <img
          v-if="selectionModalData.silk_image_url_medium"
          :src="selectionModalData.silk_image_url_medium"
          class="select-bb-modal-header__silk"
        >
        {{ competitor.name }}
      </div>
    </div>
    <div class="select-bb-modal-container">
      <div class="select-bb-modal-container__title">Upcoming Races</div>

      <div class="select-bb-modal-container__comments-text">Comment</div>
      <!-- Empty state -->
      <div v-if="noComments" class="select-bb-modal__empty-state">
        <div class="select-bb-modal__empty-icon">
          <div class="select-bb-modal__empty-state-icon"></div>
        </div>
        <div class="select-bb-modal__empty-state-txt">You haven't commented yet!</div>
        <div
          class="select-bb-modal__empty-state-subtxt"
        >Tip: This can help you keep track of why you blackbooked the runner.</div>
        <div class="select-bb-modal__empty-btn">
          <a href="#" class="select-bb-modal__write-comment" @click.prevent="toggleInput">
            <p>Write Comment</p>
          </a>
        </div>
      </div>
      <!-- Blackbook comments -->
      <template v-else>
        <div class="select-bb-comments__container">
          <SelectionBlackbookComment
            v-for="(comment, index) in blackbookComments"
            :key="`bb-comment-${index}`"
            :main-text="comment.comment"
            :time-updated="comment.timeUpdated"
          />
        </div>
      </template>
    </div>
    <!-- Edit button -->
    <div v-if="!noComments" class="select-bb-modal__edit">
      <a href="#" class="select-bb-modal__edit-btn" @click.prevent="toggleInput">
        <p>Edit Comment</p>
      </a>
    </div>
    <!-- Mask with comment input -->
    <div v-show="inputActive" class="select-bb-modal-mask" @click.prevent="toggleInput">
      <form :class="{ 'form-active': inputActive }" class="select-bb-modal-mask__form" @click.stop>
        <div class="select-bb-modal-mask__form-container">
          <input
            ref="input"
            v-model="blackbookComment"
            type="text"
            class="select-bb-modal-mask__input"
            placeholder="Add comment to blackbook"
          >
          <button
            :class="{ 'submit-active' : !inputEmpty }"
            :disabled="inputEmpty"
            class="select-bb-modal-mask__submit"
            @click.prevent="submitComment()"
          >Save</button>
        </div>
      </form>
    </div>
  </div>
</template>
